import {useEffect, useState} from "react";

export const useAwaitApiReponse = (): {
  getReponse: (apiFunction: () => Promise<any>) => Promise<any>;
  loading: boolean;
  error: any;
} => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);
  useEffect(() => {
    console.log("error", error);
  }, [error]);

  const getReponse = async (apiFunction: () => Promise<any>): Promise<any> => {
    setLoading(true);
    setError(null);
    try {
      const reponse = await apiFunction();
      setLoading(false);
      return reponse;
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  return {getReponse, loading, error};
};
